<template>
    <div class="bg-f9f9f9">
        <Mainlayout></Mainlayout>
        <div class="d-lg-block d-none"> <br /><br /></div>
        <div class="d-sm-block"><br /><br /><br /></div>
        <div class="breadcrumb-container">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <!-- Home breadcrumb -->
                    <li class="breadcrumb-item">
                        <a 
                            href="#" 
                            @click="goToTab('category')" 
                            :class="{'active': currentTab === 'category'}">
                            Home
                        </a>
                    </li>

                    <!-- Category breadcrumb (dynamic) -->
                    <li 
                        class="breadcrumb-item" 
                        v-if="selectedCategory" 
                        :class="{'active': currentTab === 'tournament' || currentTab === 'typeDetail'}">
                        <a 
                            href="#" 
                            @click="goToTab('tournament')">
                            {{ selectedCategory }}
                        </a>
                    </li>

                    <!-- Tournament breadcrumb (dynamic) -->
                    <li 
                        class="breadcrumb-item" 
                        v-if="selectedTournament" 
                        :class="{'active': currentTab === 'typeDetail' || currentTab === 'tournament'}">
                        <a 
                            href="#" 
                            @click="goToTab('typeDetail')">
                            {{ selectedTournament }}
                        </a>
                    </li>

                    <!-- Type breadcrumb (dynamic) -->
                    <li 
                        class="breadcrumb-item" 
                        v-if="selectedType" 
                        :class="{'active': currentTab === 'typeDetail'}">
                        <a 
                            href="#" 
                            @click="goToTab('typeDetail')">
                            {{ selectedType }}
                        </a>
                    </li>
                    <!-- Matching Player breadcrumb -->
                    <!-- Grouping breadcrumb -->
                <li 
                    class="breadcrumb-item" 
                    v-if="currentTab === 'grouping'" 
                    :class="{'active': currentTab === 'grouping'}">
                    <a 
                        href="#" 
                        @click="goToTab('grouping')">
                        Grouping
                    </a>
                </li>

                <li 
                    class="breadcrumb-item" 
                    v-if="currentTab === 'matching' || currentTab === 'matching'" 
                    :class="{'active': currentTab === 'matching'}">
                    <a 
                        href="#" 
                        @click="goToTab('matching')">
                        Matching Opponent
                    </a>
                </li>

                <li 
                    class="breadcrumb-item" 
                    v-if="currentTab === 'matchScore'" 
                    :class="{'active': currentTab === 'matchScore' || currentTab === 'matchScore'}">
                    Match Score
                </li>
                </ol>
            </nav>
        </div>
        
                <CCol sm="10" style="width: 90%;background-size: cover; margin: auto;">
          
                <CCard class="bg-white b-20 p-2" style="border:none">
                   
                    <div>
                        <div v-if="currentTab === 'category'">
                            <CContainer class="mt-2">
                                <h3 class="custom-48px-600 mt-5">
                            Sport Category
                        </h3>
                        <h4 class="custom-16px-400 font-color-636366 text-center mb-4">
                            Explore Dynamic Talent Across a Range of Exciting Sports Categories</h4>
                            <CRow>
                                <CCol sm="4">
                                    <CCard class="custom-card-F9F9FB border-16px" @click="selectCategory('Football')" :class="{'selected-category': selectedCategory === 'Football'}">
                                        <div v-if="selectedCategory === 'Football'" class="text-right">
                                            <img src="../assets/img/tick.png" width="40px" class="p-2" style="position:absolute;right:0"/>
                                        </div>
                                        <div class="text-center p-3">
                                            <img src="../assets/img/football.png" width="150px"/>
                                            <h3 class="custom-14px-500  font-color-171717">Football</h3>
                                        </div>
                                    </CCard>
                                </CCol>
                                <CCol sm="4">
                                    <CCard class="custom-card-F9F9FB border-16px" @click="selectCategory('Badminton')" :class="{'selected-category': selectedCategory === 'Badminton'}">
                                        <div v-if="selectedCategory === 'Badminton'" class="text-right">
                                            <img src="../assets/img/tick.png" width="40px" class="p-2" style="position:absolute;right:0"/>
                                        </div>
                                        <div class="text-center p-3">
                                        <img src="../assets/img/badminton.png" width="150px"/>
                                        <h3 class="custom-14px-500  font-color-171717">Badminton</h3>
                                        </div>
                                    </CCard>
                                </CCol>
                                <CCol sm="4">
                                    <CCard class="custom-card-F9F9FB border-16px" @click="selectCategory('Ping Pong')" :class="{'selected-category': selectedCategory === 'Ping Pong'}">
                                        <div v-if="selectedCategory === 'Ping Pong'" class="text-right">
                                            <img src="../assets/img/tick.png" width="40px" class="p-2" style="position:absolute;right:0"/>
                                        </div>
                                        <div class="text-center p-3">
                                        <img src="../assets/img/pingpong.png" width="143px"/>
                                        <h3 class="custom-14px-500  font-color-171717">Ping Pong</h3>
                                        </div>
                                    </CCard>
                                </CCol>
                            </CRow>
                        </CContainer>
                        </div>

                        <div v-if="currentTab === 'tournament'">
                            <div v-if="tour && tour.length > 0">
                                <CCol sm="12" v-for="(item,index) in tour" v-bind:key="item.Id" class="mt-3">
                                    <CCard class="p-2" @click="selectTournament(item.Title,item.Start, item.Id)">
                                        <CRow>
                                            
                                            <CCol sm="12">
                                                <h3 class="custom-14px-500 font-color-171717 text-left mt-3">
                                                    <b>
                                                                                {{ item.Title }} - {{ item.start}}
                                                                            </b>
                                                </h3>
                                            </CCol>
                                        
                                        </CRow>
                                    </CCard>
                                </CCol>
                            </div>
                            <CCol sm="12" v-else>
                                <div class="text-center m-2">
                                    <img src="../assets/img/nodata.png" alt="No Data" style="max-width:250px; margin:auto;" />
                                </div>
                            </CCol>
                        </div>

                        <div v-if="currentTab === 'typeDetail'">
                            <CContainer class="mt-2">
                                <CRow>
                                    <CCol sm="4">
                                        <CCard 
                                            class="custom-card-F9F9FB border-16px" 
                                            @click="selectType('Participant')" 
                                            :class="{'selected-type': selectedType === 'Participant'}">
                                            <div v-if="selectedType === 'Participant'" class="text-right">
                                                <img src="../assets/img/tick.png" width="40px" class="p-2" style="position:absolute;right:0"/>
                                            </div>
                                            <div class="text-center p-3">
                                                <img src="../assets/img/defaultteam.png" width="100px"/>
                                                <h3 class="custom-14px-500 font-color-171717">View Participant</h3>
                                            </div>
                                        </CCard>
                                    </CCol>
                                    <CCol sm="4">
                                        <CCard 
                                            class="custom-card-F9F9FB border-16px" 
                                            @click="selectType('Match')" 
                                            :class="{'selected-type': selectedType === 'Match'}">
                                            <div v-if="selectedType === 'Match'" class="text-right">
                                                <img src="../assets/img/tick.png" width="40px" class="p-2" style="position:absolute;right:0"/>
                                            </div>
                                            <div class="text-center p-3">
                                                <img src="../assets/img/match.png" width="100px"/>
                                                <h3 class="custom-14px-500 font-color-171717">Match Detail</h3>
                                            </div>
                                        </CCard>
                                    </CCol>
                                </CRow>
                            </CContainer>
                        </div>


                        <div v-if="currentTab === 'participant'">
                            <table class="table p-20 table-responsive-sm">
                                <thead style="background-color: #064BB4;color:#fff">
                                    <th>No</th>
                                    <th>Sport Category</th>
                                    <th>Tournament</th>
                                    <th>Team Name</th>
                                    <th>Member</th>
                                    <th></th>
                                </thead>
                                <tbody v-for="(item, index) in participants" v-bind:key="item.Id">
                                    <tr>
                                        <td>{{ index +1 }}</td>
                                        <td>{{item.Category }}</td>
                                        <td>
                                        {{ item.TournamentName }}
                                        </td>
                                    
                                        <td> <div @click="GoToAssignPlayer(item.Id)">{{ item.TeamName }}</div></td>
                                        <td><img style="width:20px" src="../assets/img/user.png" class="mr-2"/>{{ item.CountTeam }} Members</td>
                                    <td>
                                                    <div class="text-right">
                                                        <div class="button-bg-white-border-blue" @click="OpenTeam(item)">
                                                            <label style="color: #064BB4; font-size: 14px;">Detail</label>
                                                        </div>
                                                    </div>
                                    </td>
                                    </tr>
            
                                </tbody>
                            </table>
                        </div>

                        <div v-if="currentTab === 'grouping'">
                            <CContainer>
                                    <h3 class="custom-18px-500 mt-2 custom-label-grey mb-2 mt-5">
                                    
                                        <span @click="currentTab = 'grouping'" :class="{'active': currentTab === 'grouping', 'bold-text': currentTab === 'grouping'}">Grouping</span> /
                                        <span @click="currentTab = 'matching'" :class="{'active': currentTab === 'matching','bold-text': currentTab === 'matching'}"> Matching Player </span> /
                                        <span @click="currentTab = 'matchScore'" :class="{'active': currentTab === 'matchScore','bold-text': currentTab === 'matchScore'}"> Match Score</span>
                                    </h3>
                                </CContainer>
                
                            
                            <h3 class="custom-48px-400 mt-5"> Matching your opponent</h3>
                            <label class="text-center custom-label-grey"> Join tournaments and get matched with opponents at your skill level! Our "Matching Your Opponent" feature ensures fair and exciting competition by pairing you with the right challenger.</label>

                            <div v-if="showlistgroup === true">
                                <div v-for="(group, groupName) in groupedTeams" :key="groupName">
                                    <!-- Display the Group Title only once for each group -->
                                    <h3 class="custom-20px-600">Group Stage: {{ groupName }}</h3>

                                    <!-- Loop through teams in the current group -->
                                    <CRow>
                                        <CCol sm="12" v-for="(item, index) in group" :key="item.id">
                                            <CCard class="custom-card-bg-white">
                                                <CRow>
                                                    <CCol sm="1">
                                                        <img src="../assets/img/defaultteam.png" style="max-width:40px" />
                                                    </CCol>
                                                    <CCol sm="9">
                                                        <!-- Display team name -->
                                                        <h3 class="custom-14px-500 font-color-1E1E1F mt-2 text-left">{{ item.teamName }}</h3>
                                                    </CCol>
                                                    <CCol sm="2">
                                                        <div class="text-right">
                                                            <div class="button-bg-white-border-blue" @click="">
                                                                <label style="color: #064BB4; font-size: 14px;">Detail</label>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                </div>
                            </div>
                            <div v-if="showOpponentForm">
                                <div @click="BackGrouping()">
                                    <img src="../assets/img/arrow_back.png" @click="BackGrouping()" width="20px" /> <span class="font-color-171717">Back to List</span>
                                </div>
                                <br /> <br />
                                <div class="p-2">
                                    <h4 class="custom-24px-600">
                                        Group A
                                    </h4>

                                    <CRow v-for="item in detailTeam" v-bind:key="item.Id">

                                        <CCol sm="7">
                                            <label class="custom-20px-500 font-color-171717">Team : {{ item.TeamName }}</label></CCol>
                                        <CCol sm="5">
                                            <div class="text-right mb-3">
                                                <span @click="AddMember" class="button-bg-white-border-blue"> 
                                                                                                    
                                                                                                        <label class="ml-2" style="color: #064BB4; font-size: 14px; font-weight: 600;"> Add Player </label>
                                                                                                        <img src="../assets/img/add1.png" style="max-width:20px" />
                                                                                                    </span>
                                            </div>
                                        </CCol>
                                        <CCol sm="12">

                                            <CRow v-for="(item, index) in members" v-bind:key="item.Id" class="mb-1">
                                                <CCol sm="12" md="6" lg="3">
                                                    <div class="mb-1">
                                                        <v-select v-model="item.selectedType" :options="typePlayer" label="Name" placeholder="--Sila Pilih Jenis--" required style="border-radius:50px">
                                                        </v-select>
                                                    </div>
                                                </CCol>
                                                <CCol sm="12" md="6" lg="8">
                                                    <div class="mb-1">
                                                        <v-select v-model="item.selectedTeam" :options="memberlist" label="Name" placeholder="--Sila Pilih Peserta--" required style="border-radius:50px">
                                                        </v-select>
                                                    </div>
                                                </CCol>


                                                <CCol sm="12" md="12" lg="1">
                                                    <br />
                                                    <div class="mt-4">
                                                        <img src="../assets/img/trash2.png" style="max-width:20px" v-on:click="removemember(index)" />
                                                    </div>
                                                    <br />
                                                </CCol>
                                            </CRow>
                                        </CCol>

                                        <CCol sm="12" class="mt-3">
                                            <CRow>
                                                <CCol sm="3">
                                                    <label class="custom-20px-500 font-color-171717">Opponent Team : 
                                                                            
                                                                            </label></CCol>
                                                <CCol sm="9">
                                                    <v-select v-model="selectedOpponentTeam" :options="team" label="TeamName" placeholder="--Sila Pilih Team--" required style="border-radius:50px">
                                                    </v-select>
                                                </CCol>
                                            </CRow>

                                        </CCol>

                                        <CCol sm="12">
                                            <CRow class="mt-3">
                                                <CCol sm="10"></CCol>
                                                <CCol sm="2">
                                                    <div class="text-right float-right">
                                                        <CButton type="button" class="btn button-Explore text-white border-10px" @click="ConfirmOpponent()">Confirm</CButton>
                                                    </div>
                                                </CCol>


                                            </CRow>
                                        </CCol>
                                    </CRow>
                                </div>
                            </div>
                        </div>

                        <div v-if="currentTab === 'matching'">
                            <CContainer>
                                    <h3 class="custom-18px-500 mt-2 custom-label-grey mb-2 mt-5">
                                    
                                        <span @click="currentTab = 'grouping'" :class="{'active': currentTab === 'grouping', 'bold-text': currentTab === 'grouping'}">Grouping</span> /
                                        <span @click="currentTab = 'matching'" :class="{'active': currentTab === 'matching','bold-text': currentTab === 'matching'}"> Matching Player </span> /
                                        <span @click="currentTab = 'matchScore'" :class="{'active': currentTab === 'matchScore','bold-text': currentTab === 'matchScore'}"> Match Score</span>
                                    </h3>
                                </CContainer>
        
                            <h3 class="custom-48px-400 mt-5"> Matching your opponent</h3>
                            <label class="text-center custom-label-grey"> Join tournaments and get matched with opponents at your skill level! Our "Matching Your Opponent" feature ensures fair and exciting competition by pairing you with the right challenger.</label>
                    
                                <div class="p-2">
                                    <CRow>
                                        <CCol sm="12" v-if="listmatch=== true">
                                            <div v-for="(matches, groupCategory) in groupedMatches" :key="groupCategory">
                                                <!-- Display the Group Title (e.g., "Group A") once -->
                                                <div>
                                                    <h3 class="custom-20px-600">Group Stage: {{ groupCategory }}</h3>
                                                </div>
            
                                                <!-- Loop through each match in the current group -->
                                                <CRow>
                                                    <CCol sm="12" v-for="match in matches" :key="match.id">
                                                        <CCard class="custom-card-bg-white">
                                                            <CRow>
                                                                <CCol sm="3">
                                                                    <h3 class="custom-14px-500 font-color-1E1E1F mt-2">
                                                                        <img src="../assets/img/defaultteam.png" style="max-width:40px" class="mr-2" /> {{ match.teamMatch.split(' VS ')[0] }}
                                                                    </h3>
                                                                </CCol>
                                                                <CCol sm="3">
                                                                    <h3 class="custom-14px-500 font-color-1E1E1F text-center mt-3">- VS -</h3>
                                                                </CCol>
                                                                <CCol sm="3">
                                                                    <h3 class="custom-14px-500 font-color-1E1E1F mt-2">
                                                                        <img src="../assets/img/defaultteam.png" style="max-width:40px" class="mr-2" /> {{ match.teamMatch.split(' VS ')[1] }}
                                                                    </h3>
                                                                </CCol>
                                                                <CCol sm="3">
                                                                    <div class="button-bg-white-border-blue mt-2 text-right" @click="OpenMatchDetails(match.id)">
                                                                        <label style="color: #064BB4; font-size: 14px;">Match Detail</label>
                                                                    </div>
                                                                </CCol>
                                                            </CRow>
                                                        </CCard>
                                                    </CCol>
                                                </CRow>
                                            </div>
                                        </CCol>
                                    </CRow>
                                </div>
                        </div>

                        <div v-if="currentTab === 'matchScore'">
                            <CContainer>
                                    <h3 class="custom-18px-500 mt-2 custom-label-grey mb-2 mt-5">
                                    
                                        <span @click="currentTab = 'grouping'" :class="{'active': currentTab === 'grouping', 'bold-text': currentTab === 'grouping'}">Grouping</span> /
                                        <span @click="currentTab = 'matching'" :class="{'active': currentTab === 'matching','bold-text': currentTab === 'matching'}"> Matching Player </span> /
                                        <span @click="currentTab = 'matchScore'" :class="{'active': currentTab === 'matchScore','bold-text': currentTab === 'matchScore'}"> Match Score</span>
                                    </h3>
                                </CContainer>
                            <h3 class="custom-48px-400 mt-5"> Matching your opponent</h3>
                            <label class="text-center custom-label-grey"> Join tournaments and get matched with opponents at your skill level! Our "Matching Your Opponent" feature ensures fair and exciting competition by pairing you with the right challenger.</label>

                            <div v-for="(matches, groupCategory) in groupedMatches" :key="groupCategory">
                                <!-- Display the Group Title (e.g., "Group A") once -->
                                <div>
                                    <h3 class="custom-20px-600">Group Stage: {{ groupCategory }}</h3>
                                </div>
                                <CRow>
                                    <CCol sm="12" v-for="match in matches" :key="match.id">
                                        <CCard class="custom-card-bg-white">
                                            <CRow>
                                                <CCol sm="4">
                                                    <h3 class="custom-14px-500 font-color-1E1E1F mt-2">
                                                        <img src="../assets/img/defaultteam.png" style="max-width:40px" class="mr-2" /> {{ match.teamMatch.split(' VS ')[0] }}
                                                    </h3>
                                                </CCol>
                                                <CCol sm="4">
                                                    <h3 class="custom-24px-500 font-color-1E1E1F text-center mt-3">{{ match.scoreA }} <label class="ml-2 mr-2 custom-14px-500">VS</label> {{ match.scoreB }}</h3>
                                                </CCol>
                                                <CCol sm="4">
                                                    <h3 class="custom-14px-500 font-color-1E1E1F mt-2">
                                                        <img src="../assets/img/defaultteam.png" style="max-width:40px" class="mr-2" /> {{ match.teamMatch.split(' VS ')[1] }}
                                                    </h3>
                                                </CCol>
                                            </CRow>
                                        </CCard>
                                    </CCol>
                                </CRow>
                            </div>
                        </div>
                    </div>
                </CCard>
         </CCol>


        <div v-if="isPopupConfirmation" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <h3 class="custom-24px-600 font-color-171717 text-center mt-3">
                        Stay tuned for the confirmation to start your Tournament!
                    </h3>
                    <p class="custom-12px-500 font-color-171717 text-center">Join a tournament and choose your team’s opponent. After selecting, please wait for confirmation before the match begins. This ensures both teams are ready and all details are set for a smooth and fair competition. </p>
    
                    <CRow>
                        <CCol sm="4"></CCol>
                        <CCol sm="8">
                            <div class="text-right">
                                <CButton class="custom-bg-border-AEAEB2" @click="closePopup()">
                                    Cancel
                                </CButton>
                                <CButton type="button" class="bg-064BB4 text-white border-10px ml-2" @click="closePopup()">Confirm</CButton>
                            </div>
    
                        </CCol>
                    </CRow>
    
                </div>
            </div>
        </div>
    
    
        <div v-if="matchdetail" class="popup-all backdrop-all">
            <div class="popup-all2">
                <CRow>
                    <CCol sm="8">
                        
                    </CCol>
                    <CCol sm="4">
                        <div class="text-right">
                    <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupMatch" />
                </div>
                    </CCol>
                </CRow>
                <CCol sm="12">
                    <CRow>
                        <CCol sm="12">
                            <div>
                                <h3 class="custom-20px-600 mb-4"> {{ GroupNames }}</h3>
                            </div>
                        </CCol>
                        <CCol sm="5">
                            
                            <CCol sm="12" class="p-0">
                                <label class="custom-20px-500 font-color-171717 p-0">Team : {{ TeamA }}</label></CCol>
    
                            <CCol sm="12">
    
                                <CRow class="mb-2 font-color-171717">
                                        <div class="mb-2 p-2">
                                            <CRow v-for="item in membersa" v-bind:key="item.Id" class="mb-2">
                                                <CCol sm="3" style="white-space: nowrap;">{{ item.PlayerA }}</CCol>
                                                <CCol sm="9">{{ item.TeamA }}</CCol>
                                            </CRow>
                                        </div>
                                </CRow>
                            </CCol>
                        </CCol>
                        <CCol sm="2">
                            <h3 class="custom-30px-500 text-center font-color-171717 mt-5">VS</h3>
                        </CCol>
                        <CCol sm="5">
                            <div>
                                <h3 class="custom-20px-600"></h3>
                            </div>
                            <CCol sm="12" class="p-0">
                                <label class="custom-20px-500 font-color-171717 p-0">Team : {{ TeamB }}</label></CCol>
    
                            <CCol sm="12">
    
                                
                                <CRow class="mb-2 font-color-171717">
                                   
                                        <div class="mb-2 p-2">
                                            <CRow v-for="item in membersb" v-bind:key="item.Id" class="mb-2">
                                                <CCol sm="3" style="white-space: nowrap;">{{ item.PlayerB }}</CCol>
                                                <CCol sm="9">{{ item.TeamB }}</CCol>
                                            </CRow>
                                          
                                        </div>
                                    </CRow>
                                   
                            </CCol>
                        </CCol>
                    </CRow>
    
                </CCol>
            </div>
        </div>

        <div v-if="isPopupTeam" class="popup-all backdrop-all">
            <div class="popup-all2">
                <div class="text-right">
                    <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupTeam" />
                </div>
    
                <!-- Popup content -->
                <div class="custom-scroll">
                    <div class="text-left" v-for="item in detailTeam" v-bind:key="item.Id">
                        <CRow>
                            <CCol sm="1"><img src="../assets/img/defaultteam.png" style="max-width:50px" /></CCol>
                            <CCol sm="11">
                                <h3 class="custom-20px-600 text-left mt-2">{{ item.TeamName }}</h3>
                            </CCol>
                        </CRow>
    
                            <div class="m-1">
                                <table class="table p-20 table-responsive-sm" style="width:100% !important">
                                    <thead style="background-color: #064BB4;color:#fff">
                                        <th>No</th>
                                        <th>Player Name</th>
                                        <th>Sport Category</th>
                                        <th>ID Number</th>
                                        <th>Ranking Point</th>
                                        <th>Ranking No</th>
                                        <th>Status</th>
                                    </thead>
                                    <tbody v-for="(items, index) in item.ListTeam" v-bind:key="items.Id">
                                        <tr>
                                            <td>{{ index +1 }}</td>
                                            <td>{{items.Name }}</td>
                                            <td>{{ items.Category }}</td>
                                            <td>{{ formatIdentityNumber(items.IdentityNumber) }}</td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                <img src="../assets/img/triangle2.png" style="max-width:10px" />
                                            </td>
                                        </tr>
    
                                    </tbody>
                                </table>
                            </div>
                     
                    </div>
                </div>
            </div>
        </div>
    
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/Membership.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bg.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';

import msalInstance from '../containers/msalService';

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },
    data() {
        return {
            backgroundUrl,
            backgroundUrNoArrow,

            backgroundGenie,
            detailTeam: [],
            memberlist: [],
            members: [],
            typePlayer: [],
            team: [],

            currentTab: 'category',
            tour: [],
            selectedEvent: "",
            showOpponentForm: false,
            isPopupConfirmation: false,
            matchdetail: false,
            showlistgroup: true,
            teamgroup: [],
            matchteam: [],
            participants: [],


            membersa: [],
            membersb:[],
            listmatch: true,

            Categorys: "",
            TournamentNames: "",
            GroupNames: "",
            TeamA: "",
            TeamB: "",
            selectedCategory: '',
            selectedTournament: '',
            selectedType: '',
            isPopupTeam: false,

           



        };
    },
    computed: {
        groupedTeams() {
            return this.teamgroup.reduce((groups, item) => {
                if (!groups[item.groupName]) {
                    groups[item.groupName] = [];
                }
                groups[item.groupName].push(item);
                return groups;
            }, {});
        },
        groupedMatches() {
            return this.matchteam.reduce((groups, match) => {
                // Get the group category (e.g., "Group A")
                const group = match.groupCategory;

                if (!groups[group]) {
                    groups[group] = [];
                }

                groups[group].push(match);
                return groups;
            }, {});
        }
    },
    created() {
        AOS.init();

    },
    async mounted() {

        this.GetListTeamById();
        this.GetListTeamByTeamId();
        this.GetListTypePlayer();
        this.GetListTeam();
        this.GetListTour();
        this.GetListTeamGroup();
        this.GetListTeamMatchGroup();
        this.GetListParticipant();
    },
    methods: {
        GetListTeamById() {
            this.$API
                .get(this.$GetListTeamById + "?id=" + this.$route.query.id)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.detailTeam = response.data;

                    }
                });
        },
        GetListTeamByTeamId() {
            this.$API
                .get(this.$GetListTournamentByTeamIds + "?id=" + this.$route.query.id)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.memberlist = response.data;

                    }
                });
        },
        GetListTeam() {
            this.$API
                .get(this.$GetListTeam)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.team = response.data;
                    }
                });
        },
        RegisterTeam() {
            const formData = new FormData();

            var team = [];
            for (let i in this.members) {
                let item = this.members[i];

                team.push({
                    Name: item.Name,
                    PhoneNumber: item.PhoneNumber,
                    identityNumber: item.IdentityNumber,
                    TypeLevel: item.TypeLevel ? item.TypeLevel.Id : null
                });
            }
            let teamJson = JSON.stringify(team);

            formData.append("TeamName", this.TeamName);
            formData.append("ManagerName", this.ManagerName);
            formData.append("IdentityNumber", this.IdentityNumber);
            formData.append("TypeLevel", this.SelectedLevel.Id);
            formData.append("Category", this.tour.Category);
            formData.append("Amount", this.totalAmount);
            formData.append("Email", this.Email);
            formData.append("PhoneNumber", this.PhoneNumber);
            formData.append("teamJson", teamJson);
            formData.append("Title", this.tour.Title);
            formData.append("TournamentId", this.$route.query.id);

            return this.$API
                .post(this.$InsertRegistrationTeams, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.billId = response.data;
                        // this.$dialog
                        // .alert("Registered.")
                        window.open(
                            "https://www.billplz.com/bills/" + this.billId
                        );

                    }
                })
                .catch((error) => {
                    if (error.response) {
                        this.Busy = false;
                        this.Error = true;
                        console.log(error.response.status);
                    }
                });
        },

        AddMember() {
            var lastId = 1;
            var length = this.members.length;
            if (length > 0) lastId = this.members[length - 1].Id;

            this.members.push({
                Id: lastId + 1,
                Name: "",
            });
        },

        removemember: function(index) {
            this.members.splice(index, 1);
        },
        GetListTypePlayer() {
            this.$API
                .get(this.$GetListTypePlayer)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.typePlayer = response.data;
                    }
                });
        },
        GetListTour() {
            this.$API
                .get(this.$GetListTournamentByCategory + "?category=" + this.selectedCategory)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.tour = response.data;
                    }
                });
        },
        OpenOpponent() {
            this.showOpponentForm = !this.showOpponentForm;
            this.showlistgroup = !this.showOpponentForm;
        },
        ConfirmOpponent() {
            this.isPopupConfirmation = true;
        },
        closePopup() {
            this.isPopupConfirmation = false;
        },
        OpenMatchDetails(id) {
            this.matchdetail = true;
            this.GetListTeamByTeamAIdEdit(id);
            this.GetMatchDetailById(id);

        },
        BackGrouping() {
            this.showlistgroup = true;
            this.showOpponentForm = false;
        },
        selectCategory(category) {
    this.selectedCategory = category;
    this.selectedTournament = ''; // Clear the selected tournament
    this.selectedType = ''; // Clear the selected type
    this.currentTab = 'tournament'; // Set the current tab to tournament
    this.GetListTeamGroup();  // Fetch teams and groups
    this.GetListTeamMatchGroup();
    this.GetListTour();
},

// Navigate to Tournament tab
selectTournament(tournamentTitle, start, id) {
    this.selectedTournament = tournamentTitle + "-" + start; // Set the selected tournament
    this.selectedType = ''; // Clear selected type when a tournament is selected
    this.currentTab = 'typeDetail'; // Set the tab to typeDetail
    this.GetListTeamGroup(id);
    this.GetListParticipant(id);
    this.GetListTeamMatchGroup(id);
},

// Navigate to Type Detail (Participant or Match) tab
selectType(type) {
    this.selectedType = type; // Set the selected type
    if (type === 'Participant') {
        this.currentTab = 'participant'; // Switch to participant tab
    } else if (type === 'Match') {
        this.currentTab = 'grouping'; // Switch to grouping tab
    }
},

    // General function to switch tabs and reset variables when navigating backward
    goToTab(tab) {
        if (tab === 'category') {
            // Clear category, tournament, and type selections
            this.selectedCategory = ''; 
            this.selectedTournament = ''; 
            this.selectedType = ''; 
            this.currentTab = 'category'; // Set the current tab to 'category'
        } else if (tab === 'tournament') {
            // Clear tournament and type selections
            this.selectedTournament = ''; 
            this.selectedType = ''; 
            this.currentTab = 'tournament'; // Set the current tab to 'tournament'
        } else if (tab === 'typeDetail') {
            this.selectedType = ''; 
            // Just set the current tab to 'typeDetail'
            this.currentTab = 'typeDetail';
        }
        else if (tab === 'grouping') {
            this.selectedType = ''; 
            // Just set the current tab to 'typeDetail'
            this.currentTab = 'grouping';
        }
        else if (tab === 'matching') {
            // Just set the current tab to 'typeDetail'
            this.currentTab = 'matching';
        }
        else if (tab === 'matchScore') {
            // Just set the current tab to 'typeDetail'
            this.currentTab = 'matchScore';
        }
    },

        GetListParticipant(id) {
            this.$API
                .get(this.$GetListParticipantByTournamentId + "?tournamentId=" + id, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.participants = response.data;
                    }
                });
        },
        GetListTeamGroup(id) {
            this.$API
                .get(this.$GetListTeamGroupbyCategory + "?category=" + this.selectedCategory + "&tournamentId=" + id)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.teamgroup = response.data;
                    }
                });
        },
        GetListTeamMatchGroup(id) {
            this.$API
                .get(this.$GetListMatchTeambyCategory + "?category=" + this.selectedCategory + "&tournamentId=" + id)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.matchteam = response.data;
                    }
                });
        },
        GetListTeamByTeamAIdEdit(teamId) {
            this.$API
                .get(this.$GetListTournamentByTeamIds + "?id=" + teamId)
                .then((response) => {
                    console.log("Team A Data Response:", response);

                    if (response.status === 200 && response.data) {
                        this.memberlistAedit = response.data; // Update the team member list

                    }
                })
                .catch((error) => {
                    console.error("Error fetching team data:", error);
                });
        },

        // Fetch the list of team members based on group selection (same principle applies here)
        // Fetch the list of players for Team A when a new team is selected
        GetListTeamByGroupAId(teamId) {
            this.$API
                .get(this.$GetListMatchTeamGroupAById + "?id=" + teamId)
                .then((response) => {
                    console.log("Group A Team Data Response:", response);

                    if (response.status === 200 && response.data) {
                        this.membersa = response.data; // Update group member list

                        console.log("Updated membersAedit:", this.membersAedit);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching group data:", error);
                });
        },

       

        // Fetch the list of team members based on group selection (same principle applies here)
        // Fetch the list of players for Team A when a new team is selected
        GetListTeamByGroupBId(teamId) {
            this.$API
                .get(this.$GetListMatchTeamGroupBById + "?id=" + teamId)
                .then((response) => {
                    console.log("Group B Team Data Response:", response);

                    if (response.status === 200 && response.data) {
                        this.membersb = response.data; // Update group member list

                    }
                })
                .catch((error) => {
                    console.error("Error fetching group data:", error);
                });
        },
        async GetMatchDetailById(id) {
            try {
                const response = await this.$API.get(this.$GetListMatchTeamById + "?id=" + id, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.info = response.data;
                    console.log("userInfo", this.user);
                    if (response.status == 200 && this.info != null) {

                        this.Categorys = this.info.Category;
                        this.GroupNames = this.info.GroupName;
                        this.TournamentNames = this.info.TournamentName;
                        this.TeamA = this.info.TeamA;
                        this.TeamB = this.info.TeamB;
                        this.TeamAId = this.info.TeamAId;
                        this.TeamBId = this.info.TeamBId;
                    
                        this.GetListTeamByGroupAId(id);
                        this.GetListTeamByGroupBId(id);
                        this.SetupSelectedOption();

                    } else {
                        console.log(this.info.detail);
                    }

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        closePopupMatch()
        {
            this.matchdetail = false;
        },
        SignOut: function () {
        return this.$API
          .get(this.$SignOut, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
              this.$router.push("/LoginAccount");
            }
          });
      },
      OpenTeam(item) {
            this.GetListTeamById(item.Id);
            this.isPopupTeam = true;
        },
        GetListTeamById(id) {
            this.$API
                .get(this.$GetListTeamById + "?id=" + id)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.detailTeam = response.data;
                    }
                });
        },
        closePopupTeam() {
            this.isPopupTeam = false;
        },
        formatIdentityNumber(identityNumber) {
      // Convert identityNumber to a string, ensure it's not undefined or null
      const idStr = String(identityNumber || '');

      // If identityNumber has at least 4 digits, format it, otherwise return masked only
      if (idStr.length >= 4) {
        // Return the masked format with the last 4 digits
        return `******** ${idStr.slice(-4)}`;
      } else {
        // If the string is too short, return only the masked part
        return '********' + idStr;
      }
    },
     

    }



};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans&display=swap');
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}
.selected-category {
    border-radius: 16px;
border: 1px solid #064BB4;
background: rgba(6, 75, 180, 0.08);
}
</style>